<svelte:options accessors/>
<script>
    import {onMount} from 'svelte';
    import {getProductImage} from '../utils'

    export let data;
    export let files = [];
    export let ficha = [];
    export let related = [];
    export let afterMount;

    let categories = []
    let groups = [];

    let virtualStores = [];
    let otherStores = [];

    let showFicha = false;
    let groupUrl = '';

    let virtualVisible = false;
    let otherVisible = false;

    $: virtualStoresFiltered = virtualVisible ? virtualStores : virtualStores.slice(0, 18);
    $: otherStoresFiltered = otherStores ? otherStores : otherStores.slice(0, 18);

    onMount(() => {
        if (data.Tiendas) {
            for (const item of data.Tiendas) {
                if (item.Cliente.Categoria === 'virtual') {
                    virtualStores = [...virtualStores, item];
                } else {
                    otherStores = [...otherStores, item];
                }
            }
        }

        if (data.ProductoGrupos && data.ProductoGrupos.length > 0) {
            for (const pg of data.ProductoGrupos) {
                groups = [...groups, capitalize(pg.Grupo.Nombre)];
                if (!groupUrl) {
                    groupUrl = `/productos/${pg.Grupo.Slug}`;
                }
            }
        }

        if (data.ProductoCategorias && data.ProductoCategorias.length > 0) {
            for (const pc of data.ProductoCategorias) {
                categories = [...categories, capitalize(pc.Categoria.Nombre)];
            }
        }
        afterMount();
    });

    function capitalize(text) {
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }

    function getProductUrl(product) {
        let groupSlug = null;
        if (product.ProductoGrupos && product.ProductoGrupos.length > 0) {
            groupSlug = product.ProductoGrupos[0].Grupo.Slug;
        }

        if (groupSlug) {
            return `/productos/${groupSlug}/${product.Slug}`;
        } else {
            return `/productos/producto/${product.Slug}`;
        }
    }
</script>

<section>
    <div class="productBox">
        <ul class="breadcrump">
            <li><a href="/">Inicio</a></li>
            <li><a href="/productos">Productos</a></li>
            {#if groups && groups.length > 0}
                <li><a href={groupUrl}>{groups[0]}</a></li>
            {/if}

            <li><a href="#">{ data.Nombre }</a></li>
        </ul>
        <div class="productDetailmain">
            <div class="productImage">
                <div class="productboximage">
                    <img src="{getProductImage(data)}">
                </div>
                <div class="productLegalmob">
                    <div class="protuctinfo">
                        <div>
                            <img src="" alt="">
                            <h3>INFORMACIÓN DEL PRODUCTO</h3>
                        </div>
                        <p>{ categories.join(', ') }</p>
                    </div>
                    {#if data.PrincipioActivo}
                        <div class="protuctinfo">
                            <span>Principio activo</span>
                            <p>{ data.PrincipioActivo }</p>
                        </div>
                    {/if}
                    {#if data.Pais}
                        <div class="protuctinfo">
                            <span>País de Venta</span>
                            <p>{ capitalize(data.Pais.Nombre) }</p>
                        </div>
                    {/if}
                    {#if files.length > 0 || ficha.length > 0}
                        <div class="protuctinfo">
                            {#if files.length > 0}
                                <div class="btn-group">
                                    {#each files as item}
                                        <a href="{item.url}" class="blue-btn" download target="_blank">Descargar PDF</a>
                                    {/each}
                                </div>
                            {/if}
                            {#if ficha.length > 0}
                                <a on:click={() => {showFicha = !showFicha}} class="showTable-btn">Ficha Técnica</a>
                            {/if}
                        </div>
                    {/if}
                </div>
            </div>
            <div class="productDetail">
                <h1>{ data.Nombre }</h1>
                <h2>{ groups.join(', ') }</h2>
                <div class="productInfomain">
                    {#if data.Presentacion}
                    <div class="detailFilter">
                        <label for="quantity">Cantidad</label>
                        <div class="filterSelect">
                            <select name="quantity" id="quantity">
                                <option value="" selected>{ data.Presentacion }</option>
                            </select>
                        </div>
                    </div>
                    {/if}
                    {#if data.Composicion}
                    <div class="detailFilter">
                        <label for="composition">Composición</label>
                        <div class="filterSelect">
                            <select name="composition" id="composition">
                                <option value="" selected>{ data.Composicion }</option>
                            </select>
                        </div>
                    </div>
                    {/if}
                </div>
                <hr>
                <div class="productLegal">
                    <div class="protuctinfo">
                        <div>
                            <img src="" alt="">
                            <h3>INFORMACIÓN DEL PRODUCTO</h3>
                        </div>
                        <p>{ categories.join(', ') }</p>
                    </div>
                    {#if data.PrincipioActivo}
                        <div class="protuctinfo">
                            <span>Principio activo</span>
                            <p>{ data.PrincipioActivo }</p>
                        </div>
                    {/if}
                    {#if data.Pais}
                        <div class="protuctinfo">
                            <span>País de Venta</span>
                            <p>{ capitalize(data.Pais.Nombre) }</p>
                        </div>
                    {/if}
                    {#if files.length > 0 || ficha.length > 0}
                        <div class="protuctinfo">
                            {#if files.length > 0}
                                <div class="btn-group">
                                    {#each files as item}
                                        <a href="{item.url}" class="blue-btn" download target="_blank">Descargar PDF</a>
                                    {/each}
                                </div>
                            {/if}
                            {#if ficha.length > 0}
                                <a on:click={() => {showFicha = !showFicha}} class="showTable-btn">Ficha Técnica</a>
                            {/if}
                        </div>
                    {/if}
                </div>
            </div>
        </div>
        {#if ficha.length > 0}
            <div class="protuctinfo-tableContainer" class:showTable={showFicha}>
                <table class="protuctinfo-table">
                    <thead>
                    <tr>
                        <th>Cultivo</th>
                        <th>Blanco Biológico</th>
                        <th>Dosis</th>
                        <th>P.C.</th>
                        <th>P.R.</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each ficha as row}
                        <tr>
                            <td>{ row.cultivo }</td>
                            <td>{ row.blanco }</td>
                            <td>{ row.dosis }</td>
                            <td>{ row.pc }</td>
                            <td>{ row.pr }</td>
                        </tr>
                    {/each}
                    </tbody>
                </table>

            </div>
        {/if}
        <p class="productcondition">* La disponibilidad del producto depende del inventario existente en los respectivos
            canales de distribución.</p>
        {#if data.Url}
        <div class="product-links">
            <a href={data.Url} target="_blank">
                <p>Conoce más de la marca</p>
            </a>
        </div>
        {/if}
    </div>
</section>
{#if data.Tiendas && data.Tiendas.length > 0}
    <section>
        <div class="buy-main">
            <h1>Donde Comprar</h1>
            {#if virtualStores.length > 0}
                <h2>Tiendas Virtuales</h2>
            {/if}
            <div class="main-grid">
                {#if virtualStores.length > 0}
                    <div class="logos-grid">
                        {#each virtualStoresFiltered as store}
                            <div class="buy-logo">
                                <img src="{store.Cliente.Icono}" alt="{store.Cliente.Nombre}">
                                <a href="{store.Cliente.Url}" target="_blank" class="buy">Ir a comprar</a>
                            </div>
                        {/each}
                        {#if virtualStores.length > 18}
                            <a on:click={() => virtualVisible = !virtualVisible} class="seeMore-btn"
                               class:less={virtualVisible}>
                                Ver {virtualVisible ? 'menos' : 'más'}
                            </a>
                        {/if}
                    </div>
                {/if}
                {#if otherStores.length > 0}
                    <h2>Encuentranos también:</h2>
                    <div class="logos-grid">
                        {#each otherStoresFiltered as store}
                            <div class="buy-logo">
                                <img src="{store.Cliente.Icono}" alt="{store.Cliente.Nombre}">
                                <a href="{store.Cliente.Url}" target="_blank" class="buy">Ir a comprar</a>
                            </div>
                        {/each}
                        {#if otherStores.length > 18}
                            <a on:click={() => otherVisible = !otherVisible} class="seeMore-btn"
                               class:less={otherVisible}>
                                Ver {virtualVisible ? 'menos' : 'más'}
                            </a>
                        {/if}
                    </div>
                {/if}
                <!--<hr>-->
            </div>
        </div>
    </section>
{/if}

{#if related.length > 0}
    <section>
        <div class="relatedproducts">
            <h2>Productos Relacionados</h2>
            <div class="relatedgrid">
                {#each related as prod}
                    <div class="relatedsingle">
                        <img src={getProductImage(prod)} alt="">
                        <p>{prod.Nombre}</p>
                        <div class="relatedfiling">
                            <a href={getProductUrl(prod)}>Ver presentaciones &#62;</a>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </section>
{/if}
